import { createStore, applyMiddleware, compose } from 'redux';
//import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';

const inititalState = {};

let middlewares = [applyMiddleware(thunk)];
if (window.__REDUX_DEVTOOLS_EXTENSION__)
  middlewares.push(window.__REDUX_DEVTOOLS_EXTENSION__());

const store = createStore(rootReducer, inititalState, compose(...middlewares));

export default store;
